import styled from 'styled-components'

export const StyledFooter = styled.footer`
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    background: ${({ theme }) => theme.whiteTwo};
    box-shadow: 0px -2px 8px 0px rgba(144,164,183,0.3);
    z-index: 1;
`

export const StyledFooterContent = styled.div`
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
`

export const StyledFooterItem = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
`